var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "specificProduct-page" },
    [
      _vm._m(0),
      _c(
        "el-form",
        {
          ref: "queryFormRef",
          attrs: {
            model: _vm.tableFrom,
            size: "small",
            inline: "",
            "label-width": "66px",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "商品信息：", prop: "productInfo" } },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: {
                  placeholder: "请输入商品名称",
                  size: "small",
                  clearable: "",
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleSearchList($event)
                  },
                },
                model: {
                  value: _vm.tableFrom.productName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.tableFrom,
                      "productName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tableFrom.productName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "商品分类：" } },
            [
              _c("el-cascader", {
                ref: "cascader",
                staticClass: "selWidth",
                attrs: {
                  clearable: "",
                  options: _vm.merPlatProductClassify,
                  props: _vm.categoryProps,
                  size: "small",
                },
                model: {
                  value: _vm.tableFrom.categoryId,
                  callback: function ($$v) {
                    _vm.$set(_vm.tableFrom, "categoryId", $$v)
                  },
                  expression: "tableFrom.categoryId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "价格变动：" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择价格变动", clearable: "" },
                  model: {
                    value: _vm.tableFrom.priceChangeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "priceChangeType", $$v)
                    },
                    expression: "tableFrom.priceChangeType",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "淘宝涨价", value: "1" } }),
                  _c("el-option", { attrs: { label: "淘宝降价", value: "2" } }),
                  _c("el-option", { attrs: { label: "京东涨价", value: "3" } }),
                  _c("el-option", { attrs: { label: "京东降价", value: "4" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "监控状态：" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "selWidth",
                  attrs: { placeholder: "请选择监控状态", clearable: "" },
                  model: {
                    value: _vm.tableFrom.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.tableFrom, "status", $$v)
                    },
                    expression: "tableFrom.status",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "预警", value: "1" } }),
                  _c("el-option", { attrs: { label: "正常", value: "0" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleSearchList },
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt5" },
        [
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: _vm.selectedGoods.length === 0,
              },
              on: { click: _vm.openPriceAdjustModal },
            },
            [_vm._v(" 调价 ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "tableRef",
              attrs: {
                data: _vm.tableData.data,
                size: "small",
                stripe: "",
                height: "calc(100vh - 400px)",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "50",
                  fixed: "left",
                  selectable: _vm.selectable,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  type: "index",
                  width: "50",
                  index: function (index) {
                    return (
                      (_vm.tableFrom.page - 1) * _vm.tableFrom.limit + index + 1
                    )
                  },
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productId",
                  label: "商品ID",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品",
                  "min-width": "180",
                  prop: "productName",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "规格",
                  prop: "specName",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商户",
                  prop: "merchantName",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "当前售价",
                  prop: "txPrice",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "淘宝价",
                  prop: "latestTaobaoPrice",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "与淘宝变动幅度", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: _vm.getDiffClass(scope.row.latestTaobaoDiff),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(scope.row.taobaoDiffDisplay) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "latestJdPrice",
                  label: "京东价",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "与京东变动幅度", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: _vm.getDiffClass(scope.row.latestJdDiff) },
                          [_vm._v(" " + _vm._s(scope.row.jdDiffDisplay) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currentStatusName",
                  label: "监控状态",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "140", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "a",
                          {
                            staticClass: "mr10",
                            on: {
                              click: function ($event) {
                                return _vm.openForm(
                                  scope.row.productId,
                                  scope.row.skuId
                                )
                              },
                            },
                          },
                          [_vm._v("预警设置")]
                        ),
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetailModal(
                                  scope.row.productId,
                                  scope.row.skuId
                                )
                              },
                            },
                          },
                          [_vm._v("预警详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "template",
                { slot: "empty" },
                [_c("el-empty", { attrs: { description: "暂无数据~" } })],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "page-sizes": [10, 20, 40, 60, 80],
              "page-size": _vm.tableFrom.limit,
              "current-page": _vm.tableFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _c("SpecificProductRulesForm", {
        ref: "formRef",
        on: { success: _vm.getList },
      }),
      _c("MonitorDetailModal", { ref: "detailModalRef" }),
      _c("MonitorPriceAdjustModal", {
        ref: "priceAdjustModalRef",
        on: { success: _vm.handleAdjustSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips-box flex items-center mb20" }, [
      _c("span", { staticClass: "tips-label" }, [_vm._v("商品价格监控列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }